import { useRef } from "react";
import { FleetManagementRow } from "../../types/FleetManagement-row.types";

function haveSameIds(a: FleetManagementRow[], b: FleetManagementRow[]): boolean {
  if (a.length !== b.length) return false;

  const ids = new Set(a.map(r => r.id));

  for (const row of b) {
    if (!ids.has(row.id)) return false;
  }

  return true;
}

export function useStableFleetData(
  data: FleetManagementRow[] | undefined
): FleetManagementRow[] | undefined {
  const prevRef = useRef<FleetManagementRow[] | undefined>(data);

  if (!prevRef.current || !data) {
    prevRef.current = data;
    return data;
  }

  if (!haveSameIds(prevRef.current, data ?? [])) {
    prevRef.current = data;
  }

  return prevRef.current;
}
